module.exports = __webpack_public_path__ + "fonts/7cd8d469fd0495f61234db8c321b0554.svg";